import React from 'react';
import { useDroppableHeaderContext } from '../droppableHeaderV2.hook';
import { Button } from 'antd';
import PlusGlyph from '../../../../assets/icons/Glyph/PlusGlyph';

type DroppableHeaderActionButtonProps = {
  label: string;
  onClick: () => void;
  withIcon?: boolean;
  dataTestId?: string;
};

export function DroppableHeaderActionButton({ label, onClick, withIcon, dataTestId }: DroppableHeaderActionButtonProps) {
  const { color, handleClickEvent } = useDroppableHeaderContext();
  const buttonClassName = color === 'GREEN' ? 'btn-green-primary' : 'btn-gray-light';
  const iconColor = color === 'GREEN' ? '#FFFFFF' : '#515253';
  return (
    <Button
      type='primary'
      size='small'
      className={`button-with-icon ${buttonClassName}`}
      onClick={e => handleClickEvent(e, onClick)}
      data-testid={dataTestId}>
      {withIcon && (
        <span className='icon-container'>
          <PlusGlyph color={iconColor} />
        </span>
      )}
      {label}
    </Button>
  );
}
